import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e2a257e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "accordion-005",
  open: ""
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("summary", null, "企画基本情報", -1))
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "displayflex" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "w20p" }, "企画ID", -1))
const _hoisted_6 = { class: "w80p" }
const _hoisted_7 = ["value"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  type: "hidden",
  name: "kikakuId",
  id: "kikaku_id"
}, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  type: "hidden",
  name: "kaisyaId",
  id: "kaisya_id"
}, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  type: "hidden",
  name: "syosiFlg",
  id: "syosi_flg"
}, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "w20p" }, "タイトル", -1))
const _hoisted_12 = {
  key: 0,
  class: "error_message"
}
const _hoisted_13 = {
  key: 1,
  class: "ryuyomoto",
  id: "kikaku_title"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "w20p" }, "タイトル(カナ)", -1))
const _hoisted_15 = {
  key: 0,
  class: "ryuyomoto",
  id: "kikaku_title_kana"
}
const _hoisted_16 = { class: "displayflex" }
const _hoisted_17 = { class: "w50p" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "w40p" }, "商品区分", -1))
const _hoisted_19 = ["value"]
const _hoisted_20 = { class: "w50p" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "w30p label_soutei" }, "商品分類", -1))
const _hoisted_22 = ["value"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "w20p",
  for: ""
}, "搬入希望月", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "w20p",
  for: ""
}, "企画中止", -1))
const _hoisted_25 = { class: "toggle-button-1" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "w20p",
  for: ""
}, "企画中止理由", -1))
const _hoisted_27 = ["readonly"]

import axios from "axios";
import { ref, watch, watchEffect, onMounted, computed } from "vue";
import { useStore } from "vuex";
import ModalRyuyo from "../modal/ModalRyuyo.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'KikakuKihon',
  props: {
  kikakuData: Object,
},
  setup(__props, { expose: __expose }) {

const store = useStore();
const kikakuId = ref();
const kikakuMei = ref("");
const kikakuMeiKana = ref("");
const syohinKbnId = ref(0);
const syohinBunruiId = ref(0);
const hannyuKiboYearAndMonth = ref("");
const version = ref();
const isCancel = ref(false);
const cancelRiyu = ref();

const syohinBunrui = ref();
const syohinKbn = ref();

const modalSelect = ref("");
const oldData = ref();



const kikakuData = ref();
// 検索クエリ
const searchQuery = ref("");
// 検索結果を計算する
const filteredKikakuData = computed(() => {
  if (!searchQuery.value) {
    return kikakuData.value;
  }
  return kikakuData.value.filter((kikaku: { kikakuMei: string }) =>
    kikaku.kikakuMei.toLowerCase().includes(searchQuery.value.toLowerCase())
  );
});

const props = __props;

// エラーバリデーション
const isShowError = ref(false);
const errorList = ref({
  title: "",
  cancelRiyu:""
});
const validData = () => {
  isShowError.value = false;
  errorList.value = {
    title: "",
    cancelRiyu: "",
  };
  // タイトル
  if (kikakuMei.value === "") {
    isShowError.value = true;
    errorList.value.title = "タイトルを入力してください";
  }

  if (isShowError.value) {
    return true;
  } else {
    return false;
  }
};

watchEffect(() => {
  if (props.kikakuData) {
    kikakuId.value = props.kikakuData.kikakuId || null;
    kikakuMei.value = props.kikakuData.kikakuMei || "";
    kikakuMeiKana.value = props.kikakuData.kikakuMeiKana || null;
    syohinKbnId.value = props.kikakuData.syohinKbnId || null;
    syohinBunruiId.value = props.kikakuData.syohinBunruiId || null;
    hannyuKiboYearAndMonth.value =
      props.kikakuData.hannyuKiboYearAndMonth || null;
    version.value = props.kikakuData.version;
    isCancel.value = props.kikakuData.isCancel;
    cancelRiyu.value = props.kikakuData.cancelRiyu;
  }
});

watch(
  [
    kikakuId,
    kikakuMei,
    kikakuMeiKana,
    syohinKbnId,
    syohinBunruiId,
    hannyuKiboYearAndMonth,
    version,
    isCancel,
    cancelRiyu,
  ],
  () => {
    store.commit("createKikaku", {
      kikaku: {
        kikakuId: kikakuId.value,
        kikakuMei: kikakuMei.value,
        kikakuMeiKana: kikakuMeiKana.value,
        syohinKbnId: syohinKbnId.value || null,
        syohinBunruiId: syohinBunruiId.value || null,
        hannyuKiboYearAndMonth: hannyuKiboYearAndMonth.value || null,
        version: version.value,
        isCancel: isCancel.value,
        cancelRiyu: cancelRiyu.value || null,
      },
    });
  }
);

onMounted(() => {
  oldData.value = props.kikakuData;
  // 商品区分
  axios
    .get(`${store.getters["getBaseUrl"]}/searchItemList/syohin-kbn`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      },
    })
    .then((response) => {
      syohinKbn.value = response.data;
    });

});

// 商品分類

axios
  .get(`${store.getters["getBaseUrl"]}/searchItemList/syohin-bunrui`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  .then((res) => {
    syohinBunrui.value = res.data;
  });

const modal = ref(false);
const ryuyoBtn = () => {
  modal.value = true;
  store.commit("createKikakuClear");
};

const closeBtn = () => {
  modal.value = false;
};
const ryuyoCopy = ref(false);
const closeselectBtn = (value: any) => {
  selectKikaku(value);
  modal.value = false;
  ryuyoCopy.value = true;
};

const selectKikaku = (selectId: any) => {
  axios
    .get(`${store.getters["getBaseUrl"]}/kikaku/detail?kikakuId=${selectId}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      },
    })
    .then((response) => {
      modalSelect.value = response.data;
    });
};

const Copy = (value: string) => {
  navigator.clipboard.writeText(value);
};

__expose({
  validData,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("details", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("input", {
            type: "text",
            class: "text_box readonly margin_r_10",
            value: kikakuId.value,
            readonly: ""
          }, null, 8, _hoisted_7),
          (modal.value)
            ? (_openBlock(), _createBlock(ModalRyuyo, {
                key: 0,
                onCloseModal: closeBtn,
                onChildEvent: closeselectBtn
              }))
            : _createCommentVNode("", true),
          _hoisted_8,
          _hoisted_9,
          _hoisted_10
        ])
      ]),
      _createElementVNode("div", null, [
        _hoisted_11,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((kikakuMei).value = $event)),
          class: "text_box w70p hissu"
        }, null, 512), [
          [_vModelText, kikakuMei.value]
        ]),
        (isShowError.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(errorList.value.title), 1))
          : _createCommentVNode("", true),
        (ryuyoCopy.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_13, [
              _createTextVNode(" （流用元） " + _toDisplayString(modalSelect.value.kikakuMei) + " ", 1),
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (Copy(modalSelect.value.kikakuMei))),
                type: "button",
                class: "fa fa-copy btn_copy"
              }, " コピー ")
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", null, [
        _hoisted_14,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((kikakuMeiKana).value = $event)),
          class: "text_box w70p"
        }, null, 512), [
          [_vModelText, kikakuMeiKana.value]
        ])
      ]),
      (ryuyoCopy.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_15, [
            _createTextVNode(" （流用元） " + _toDisplayString(modalSelect.value.kikakuMeiKana) + " ", 1),
            _createElementVNode("button", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (Copy(modalSelect.value.kikakuMeiKana))),
              type: "button",
              class: "fa fa-copy btn_copy"
            }, " コピー ")
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _withDirectives(_createElementVNode("select", {
            name: "",
            id: "",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((syohinKbnId).value = $event)),
            class: "text_box kikaku_select"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(syohinKbn.value, (option, index) => {
              return (_openBlock(), _createElementBlock("option", {
                value: option.syohinKbnId,
                key: index
              }, _toDisplayString(option.syohinKbn), 9, _hoisted_19))
            }), 128))
          ], 512), [
            [_vModelSelect, syohinKbnId.value]
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _hoisted_21,
          _withDirectives(_createElementVNode("select", {
            name: "",
            id: "",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((syohinBunruiId).value = $event)),
            class: "text_box kikaku_select"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(syohinBunrui.value, (option, index) => {
              return (_openBlock(), _createElementBlock("option", {
                value: option.syohinBunruiId,
                key: index
              }, _toDisplayString(option.syohinBunrui), 9, _hoisted_22))
            }), 128))
          ], 512), [
            [_vModelSelect, syohinBunruiId.value]
          ])
        ])
      ]),
      _createElementVNode("div", null, [
        _hoisted_23,
        _withDirectives(_createElementVNode("input", {
          type: "month",
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((hannyuKiboYearAndMonth).value = $event)),
          class: "text_box w40p"
        }, null, 512), [
          [_vModelText, hannyuKiboYearAndMonth.value]
        ])
      ]),
      _hoisted_24,
      _createElementVNode("label", _hoisted_25, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((isCancel).value = $event))
        }, null, 512), [
          [_vModelCheckbox, isCancel.value]
        ])
      ]),
      _createElementVNode("span", null, _toDisplayString(isCancel.value ? "ON" : "OFF"), 1),
      _createElementVNode("div", null, [
        _hoisted_26,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((cancelRiyu).value = $event)),
          class: "text_box w40p",
          readonly: !isCancel.value
        }, null, 8, _hoisted_27), [
          [_vModelText, cancelRiyu.value]
        ])
      ])
    ])
  ]))
}
}

})